import React, { Component } from 'react'
import moment from 'moment'
import SelectField from './SelectField'
import { gettext } from 'django';
import { DateRangePicker } from 'react-dates'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const accomodationTypes = (
  window.projectName === 'strasko'
  ? [
      { value: '2661e90dcbb0284da44e643cc90bad75', label: gettext('Camping pitch') },
      { value: '43b6061b11e63e4391d09b0aeaefe7d8', label: gettext('Mobile Homes') },
      { value: '5760df4b8dae646cdcb249fb8057d215', label: gettext('Glamping Tents') }
    ]
  : [
      { value: 'de685268e1336b31239107b1a9d7d3b2', label: gettext('Camping') },
      { value: '4baafab14ea09fd3ebba6ec0408b7629', label: gettext('Mobile Homes') }
    ]
)

const year = moment().year()

// Real month values, 1-12
const minMonth = window.projectName === 'strasko' ? 4: 1
const maxMonth = window.projectName === 'strasko' ? 10 : 12
const minDayOnMinMonth = window.projectName === 'strasko' ? 21 : 1
const maxDayOnMaxMonth = window.projectName === 'strasko' ? 8 : 31

export class Booking extends Component {
  getSelectedAccommodation = () => {
    if (window.page_class === 'camping') return accomodationTypes[0].value
    if (window.page_class === 'mobile-homes') return accomodationTypes[1].value

    return ''
  }

  state = {
    startDate: null,
    endDate: null,
    focusedInput: null,
    open: {
      mobile: false,
      desktop: cookies.get('bookingOpen') ? cookies.get('bookingOpen') === 'true' : true
    },
    schema: {
      hotel: this.getSelectedAccommodation(),
      check_in_day: '',
      check_in_month: '',
      check_in_year: '',
      nights: '',
      persons: ''
    }
  }

  componentWillMount() {
    this.updateWidth()
    window.addEventListener('resize', this.updateWidth.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth.bind(this))
  }

  updateWidth = () => {
    this.setState({ windowWidth: window.innerWidth, focusedInput: null })
  }

  handleChanges = event => {
    const name = event.target.name
    const value = event.target.value
    let schema = this.state.schema
    schema[name] = value
    this.setState({ schema })
  }

  handleDateChange = ({ startDate, endDate }) => {
    let schema = this.state.schema

    if (startDate) {
      schema.check_in_day = startDate.date()
      schema.check_in_month = startDate.month() + 1
      schema.check_in_year = startDate.year()
    }
    if (startDate && endDate) {
      schema.nights = endDate.diff(startDate, 'days')
    }

    this.setState({ startDate, endDate, schema })
  }

  handleSubmit = event => {
    if (this.state.schema.hotel === '' || !this.state.startDate || !this.state.endDate) {
      event.preventDefault()
    }
  }

  toggle = () => {
    let open = this.state.open
    const key = this.state.windowWidth >= 1024 ? 'desktop' : 'mobile'
    open[key] = !open[key]
    if (key === 'desktop' && cookies.get('noticeAccepted')) {
      cookies.set('bookingOpen', open.desktop, { path: '/' })
    }
    this.setState({ open })
  }

  getLabel = () => {
    const key = this.state.windowWidth >= 1024 ? 'desktop' : 'mobile'
    return `${this.state.open[key] ? gettext('Close') : gettext('Online booking')}`
  }

  isDayBlocked = date => {
    const day = date.date()
    const month = date.month() + 1

    if (month < minMonth || month > maxMonth) return true
    if (month === minMonth && day < minDayOnMinMonth) return true
    if (month === maxMonth && day > maxDayOnMaxMonth) return true

    return false
  }

  initialVisibleMonth = () => {
    const currentMonth = moment().month() + 1; //returns 0 to 11
    const initialDate = moment();
    const maxDate = moment({year: year, month: maxMonth-1, day: maxDayOnMaxMonth});

    if (currentMonth < minMonth) {
      initialDate.month(minMonth - 1);
    } else if (initialDate > maxDate ) {
      initialDate.add(1, 'year').month(minMonth - 1);
    }
    return initialDate;
  }

  render = () => (
    <div className={`container with-gap booking-outer-wrapper ${this.state.open.desktop ? 'open-desktop' : 'closed-desktop'} ${this.state.open.mobile ? 'open-mobile' : 'closed-mobile'}`}>
      <div className='toggler' onClick={this.toggle}>
        { this.getLabel() }
        <svg width="12px" height="7px" viewBox="0 0 12 7">
          <g id="0_1_1_D_Omisalj_ComingSoon_Landing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-1308.000000, -18.000000)">
            <g id="Group-8" transform="translate(120.000000, 10.000000)" fill={this.props.closeCaretColor} fillRule="nonzero">
              <g id="Group-6" transform="translate(984.000000, 0.000000)">
                <path d="M213.008579,6.90644068 C213.556126,6.90644068 214,6.4796694 214,5.95322034 C214,5.42677128 213.556126,5 213.008579,5 L206.991421,5 C206.443874,5 206,5.42677128 206,5.95322034 L206,12.0467797 C206,12.5732287 206.443874,13 206.991421,13 C207.538967,13 207.982841,12.5732287 207.982841,12.0467797 L207.982841,6.90644068 L213.008579,6.90644068 Z" id="Dropdown_icon" transform="translate(210.000000, 9.000000) rotate(-135.000000) translate(-210.000000, -9.000000) "></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <form action='https://hadria.book-official-website.com/booking.php' method='post' id='phobs_book' name='phobs_book' /*onSubmit={this.handleSubmit}*/>
        <div className='columns'>
          <div className='column booking-wrapper'>
            <div className='columns'>
              <div className='column is-3 accomodation-type'>
                <label>{gettext('Accommodation type')}</label>
                <SelectField name='hotel' placeholder={gettext('Select accommodation type')} displayProp='label' valueProp='value' options={accomodationTypes} changeCallback={this.handleChanges} value={this.state.schema.hotel} caretColor={this.props.caretColor} />
              </div>
              <div className='column is-6 dates'>
                <div className='columns'>
                  <div className='column picker-button'>
                    <div className={`datepicker-${window.projectName}`}>
                      <div className='dates-labels'>
                        <label>{gettext('Arrival')}</label>
                        <label>{gettext('Departure')}</label>
                      </div>
                      <DateRangePicker
                        openDirection='up'
                        startDatePlaceholderText={gettext('Arrival')}
                        endDatePlaceholderText={gettext('Departure')}
                        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                        startDateId='start-date' // PropTypes.string.isRequired,
                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                        endDateId='end-date' // PropTypes.string.isRequired,
                        onDatesChange={this.handleDateChange} // PropTypes.func.isRequired,
                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired
                        firstDayOfWeek={1}
                        numberOfMonths={this.state.windowWidth >= 769 ? 2 : 1}
                        displayFormat='DD/MM/YYYY'
                        isDayBlocked={this.isDayBlocked}
                        initialVisibleMonth={this.initialVisibleMonth}
                      />
                    </div>
                    <button name='book' type='submit' className={window.projectName === 'strasko' ? 'btn-orange-light' : 'btn-blue'}>{gettext('Book now')}</button>
                  </div>
                </div>
              </div>
              <div className='column is-3 reservation'>
                <span className={`or ${window.projectName}`}></span>
                <label>&nbsp;</label>
                <a
                  href={window.RESERVATIONS_URL}
                  className={`is-button ${window.projectName === 'strasko' ? 'btn-blue-light' : 'btn-orange'}`}
                  style={{'fontSize': `${window.LANGUAGE_CODE === 'sl' && '14px'}`}}
                >
                  {gettext('Booking request')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <input name='check_in_day' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_day} />
        <input name='check_in_month' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_month} />
        <input name='check_in_year' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_year} />
        <input name='nights' type='hidden' style={{ display: 'none' }} value={this.state.schema.nights} />
        <input name='company_id' type='hidden' value='d6f4fb477c77d9e54204b9d724c9f780' style={{ display: 'none' }} />
      </form>
    </div>
  )
}

export default Booking



// WEBPACK FOOTER //
// ./src/js/Booking.js